import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-external',
    templateUrl: './external.component.html',
    styleUrls: ['./external.component.scss']
})
export class ExternalComponent implements OnInit {
  public url = "";
  constructor(private route:ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParams.subscribe(resp=>{
      if(resp && resp.url){
        this.url = resp.url;
      }
      else{
// $&("parameter 'url' is missing")
      }

    })
  }

}
